/**
 * Whether this browser runs on an Apple platform, for choosing between ⌘ and
 * Ctrl in shortcut labels.
 *
 * Reads `userAgentData.platform` where available, falling back to the UA
 * string. `navigator.platform` is deprecated and already frozen to "MacIntel"
 * on Apple silicon, so it is not a safe probe.
 *
 * The match MUST be case-insensitive: `userAgentData.platform` reports "macOS"
 * (lower-case m), while the UA string carries "Macintosh". A case-sensitive
 * /Mac/ silently fails on every Chromium browser on macOS and renders Ctrl
 * where ⌘ belongs.
 */
export function isApplePlatform(): boolean {
    if (typeof navigator === 'undefined') return false;
    const userAgentData = Reflect.get(navigator, 'userAgentData');
    const reportedPlatform =
        typeof userAgentData === 'object' && userAgentData !== null
            ? Reflect.get(userAgentData, 'platform')
            : undefined;
    const platform =
        typeof reportedPlatform === 'string' && reportedPlatform.trim() ? reportedPlatform : navigator.userAgent;
    return /mac|iphone|ipad|ipod/i.test(platform);
}
